// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"365":"90dad4e4","873":"9c7ea39a"}[chunkId] + ".chunk.js";
};